(function () {
    'use strict';

    // @ngInject
    function SecondLevelNavigationBookkeepingControllerCtor($scope, $injector, $stateParams, $state, AnalyticsService, AppStates, UsersManager, moment, FeaturesService, DeviceService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'SecondLevelNavigationBookkeepingController';
        
        this.menuItemsViewModel = [];
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.moment = moment;

        this.user = UsersManager.getCurrUser();

        //prepare the view model
        // this.title = $state.$current.data.title;
        this.title = 'Bookkeeping';
        
        this.navigationMenuItems = [{
            linkTitleKey: 'Payments',
            stateToGoto: AppStates.root_core_navigation_reports_payments
        }];

        if (this.user.isCompanyOwner()) {
            this.navigationMenuItems.push(
                { linkTitleKey: 'Expenses',
                  stateToGoto: AppStates.root_core_navigation_expenses
                });
        }
        
        if (this.user.isCompanyOwner()) {
            this.navigationMenuItems.push(
                { linkTitleKey: 'Profit & Loss',
                  stateToGoto: AppStates.root_core_navigation_profit_loss
                });
        }

        if (this.user.isCompanyOwner()) {
            this.navigationMenuItems.push(
                { linkTitleKey: 'Quickbooks',
                    stateToGoto: AppStates.root_core_navigation_settings_companySettings_quickbooks
                });
        }

        // this.navigationMenuItems.push(
        //     { linkTitleKey: 'Bank Account Details',
        //         stateToGoto: AppStates.root_core_navigation_bank_account_data
        //     });

        if (this.user.isCompanyOwner() && (this.user.eligible_for_loans || this.user.eligible_for_qwil_loans)) {
            this.navigationMenuItems.push(
                { linkTitleKey: 'Advanced Withdrawal',
                    stateToGoto: AppStates.root_core_navigation_loans
                });
        }

        if (!DeviceService.checkIfMobileSize() &&
            this.user.isFeatureActive(FeaturesService.rolloutFeatures.tax_mgmt)) {
            this.navigationMenuItems.push(
                {
                    linkTitleKey: 'Taxes',
                    stateToGoto: AppStates.root_core_navigation_track
                });
        }


        if (this.user.isCompanyOwner() &&
            this.user.isFeatureActive(FeaturesService.rolloutFeatures.cashflow)) {
            this.navigationMenuItems.push(
                {
                    linkTitleKey: 'Finances',
                    stateToGoto: AppStates.root_core_navigation_cashflow
                });
        }

    }

    Controllers.SecondLevelNavigationBookkeepingController = Class(Controllers.BaseController, {
        constructor: SecondLevelNavigationBookkeepingControllerCtor,

        onMenuItemClicked: function onMenuItemClicked(menuItem) {
            this.goToState(menuItem.stateToGoto);
        }
    });
}());
